import Wizard, { WizardStepConfig } from "@/components/shared/Wizard/Wizard";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "@/components/primitives/dialog";
import { useState } from "react";
import { Button } from "@/components/primitives/button";
import { useTranslation } from "react-i18next";
import StartStep from "../RecoveryKey/StartStep";
import PasswordStep from "../RecoveryKey/PasswordStep";
import WordsStep from "../RecoveryKey/WordsStep";
import ConfirmPhraseEncryptStep from "../RecoveryKey/ConfirmPhraseEncryptStep";
import { useAuthState } from "@/zustand/AuthState";

export default function RegenerateRecoveryKeyWizard() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const encryptedPassword = useAuthState((state) => state.encryptedPassword);

  const steps: WizardStepConfig[] = [
    {
      name: "Start",
      dataKey: "start",
      component: StartStep,
    },
    {
      name: "Password",
      dataKey: "password",
      component: PasswordStep,
    },
    {
      name: "Words",
      dataKey: "words",
      component: WordsStep,
    },
    {
      name: "Confirm Phrase",
      dataKey: "confirmPhrase",
      component: ConfirmPhraseEncryptStep,
    },
  ];
  const buttonText = encryptedPassword
    ? "securityMenu.regeneratePhrase"
    : "securityMenu.generatePhrase";
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="font-normal">
          {t(buttonText)}
        </Button>
      </DialogTrigger>
      <DialogContent
        className="h-full min-w-full p-6 md:h-auto md:min-w-[43rem]"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogTitle className="hidden" />
        <DialogDescription className="hidden" />
        <Wizard steps={steps} onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}
